export enum JourneyType {
    OneWay = "OneWay",
    OpenReturn = "OpenReturn",
    Return = "Return"
}
